import { useState, useEffect } from "react";

/**
 * Debounces a value by the given delay (default 300ms).
 * Returns the debounced value — updates only after the delay has elapsed
 * without the input value changing.
 *
 * Requirements: 5.5, 6.2
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
}
